import React from 'react'
import './services.css'
import { BiCheck } from 'react-icons/bi'
import { ServicesData } from './ServicesData'
const Services = () => {
  return (
    <section id='experience'>
      <h5>
        Work
      </h5>
      <h2>
        Experience
      </h2>

      <div className='container services__container'>
        {ServicesData.map((item,index)=>{
          return (
            <article className='service'>
              <div className='service__head'>
              <h2 className='company-name'>{item.company}</h2>
              <h3>{item.title}</h3>
              </div>
              {item.data}
                <div className='services__item-cta'>
                    <a href={item.link} target='_blank' className='btn'>More Info</a>
                </div>
              </article>
              
          )

        })}
        

        </div>

    </section>
  )
}


export default Services